$(document).ready(function () {
  $('.js-groups-tile').each(function(){
    var data = $(this).data('chart-data'),
        canvas = $(this).find('canvas').get(0),
        config = {
          labels: data[0],
          datasets: [{
            fill: true,
            lineTension: 0.1,
            backgroundColor: '#EAF4F7',
            borderColor: '#E2E6E8',
            borderWidth: 1,
            borderDash: [],
            borderJoinStyle: 'round',
            pointBorderColor: '#E2E6E8',
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointRadius: 2,
            pointHitRadius: 10,
            pointHoverBackgroundColor: 'white',
            pointHoverBorderColor: '#E2E6E8',
            label: 'Completed Exercises',
            data: data[1],
          }]
        },
        tooltipOptions = {
          callbacks: {
            label: function(tooltipItems, data) {
              return tooltipItems.yLabel + ' ' + data.datasets[tooltipItems.datasetIndex].label;
            }
          }
        };
    renderCanvas(data, canvas, config, tooltipOptions);
  });

  $('.js-groups-tile-v2').each(function(){
    var data = $(this).data('chart-data'),
        canvas = $(this).find('canvas').get(0),
        config = {
          labels: data[0],
          datasets: [{
            fill: false,
            lineTension: 0.1,
            backgroundColor: '#EAF4F7',
            borderColor: '#33aacc',
            borderWidth: 1,
            borderDash: [],
            borderJoinStyle: 'round',
            pointBorderColor: '#33aacc',
            pointBackgroundColor: '#33aacc',
            pointBorderWidth: 1,
            pointRadius: 4,
            pointHitRadius: 10,
            pointHoverBackgroundColor: 'white',
            pointHoverBorderColor: '#E2E6E8',
            label: 'Completed Exercises',
            data: data[1],
          }]
        },
        tooltipOptions = {
          backgroundColor: '#fff',
          titleColor: '#3d4251',
          bodyColor: '#3d4251',
          callbacks: {
            label: function(tooltipItems, data) {
              return tooltipItems.yLabel + ' ' + data.datasets[tooltipItems.datasetIndex].label;
            }
          }
        };
    renderCanvas(data, canvas, config, tooltipOptions);
  });

  function renderCanvas(data, canvas, config, tooltipOptions) {
    if (canvas) {
      var ctx = canvas.getContext('2d'),
          max = Math.max.apply(null, data[1]);
      new Chart(ctx, {
        type: 'line',
        data: config,
        options: {
          maintainAspectRatio: false,
          responsive: true,
          animation: false,
          tooltips: tooltipOptions,
          scales: {
            xAxes: [{
              display: false
            }],
            yAxes: [{
              display: false,
              ticks: {
                suggestedMax: max + (parseFloat(max)/10.0),
                min: 0,
                stepSize: 0.5,
              },
            }]
          },
          legend: {
            display: false
          },
          class: 'chart'
        }
      });
    }
  }
});
